angular.module('impactx.budget').controller('BudgetTemplateCtrl', BudgetTemplateCtrl);
BudgetTemplateCtrl.$inject = ['$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$routeParams',
    'ToolbarService'
];

function BudgetTemplateCtrl($scope, dataGen, BackService, $mdToast, ConfirmationService, $routeParams, ToolbarService) {
    var templateId = $routeParams.id;
    var ctrl = this;

    this.save = function () {
        var dataObj = {
            template: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/budgetTemplate/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/budgetTemplate/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    dataGen.getData($scope, {id: templateId}, "/budgetTemplate/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: isEditable
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}